import React from "react";
import { ButtonRow } from "./toolbar-design-system";
import styles from "./line-width-slider.module.css";

export function LineWidth({
  value,
  onChange,
  start,
  step,
  count,
}: {
  value: number;
  onChange: (value: number) => void;
  start?: number;
  step?: number;
  count?: number;
}) {
  return (
    <ButtonRow>
      <InputRangeWithMarks value={value} onChange={onChange} start={start} step={step} count={count} />
    </ButtonRow>
  );
}

function InputRangeWithMarks({
  value,
  start = 1,
  step = 1,
  count = 10,
  onChange,
  backgroundColor = "#657E9A",
  foregroundColor = "#FFFFFF",
}: {
  value: number;
  start?: number;
  step?: number;
  count?: number;
  onChange: (value: number) => void;
  backgroundColor?: string;
  foregroundColor?: string;
}) {
  const spacing = 100 / (count - 1); // I want all points to fit in 100 units of svg
  const valuePct = (100 * (value - start)) / (step * (count - 1));

  function makeStops() {
    const result = [];
    const radius = 3;
    for (let i = 0; i < count; i++) {
      result.push(
        <circle
          key={i}
          cx={i * spacing}
          r={radius}
          fill={i * step + start <= value ? foregroundColor : backgroundColor}
        />
      );
    }
    return result;
  }

  return (
    <div style={{ position: "relative", width: "100%", height: "17px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: "absolute", left: "-5px", right: "-5px", pointerEvents: "none" }}
        viewBox="-10 -10 120 20"
      >
        <defs>
          <linearGradient id="background">
            <stop offset={valuePct + "%"} stopColor={foregroundColor} />
            <stop offset={valuePct + "%"} stopColor={backgroundColor} />
          </linearGradient>
        </defs>
        <rect y="-1" width="100" height="2" rx="2.5" fill="url(#background)" />
        {makeStops()}
        <circle
          key="handle"
          cx={Math.round((value - start) / step) * spacing}
          cy="0"
          r="5"
          stroke="white"
          fill={foregroundColor}
          strokeWidth={1}
        />
      </svg>
      <input
        className={styles.widthSlider}
        type="range"
        min={start}
        max={start + step * (count - 1)}
        step={step}
        value={value}
        onChange={(e) => {
          onChange(e.target.valueAsNumber);
        }}
      />
    </div>
  );
}
